/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TBulkUpdateNotificationsRequest } from '../models/TBulkUpdateNotificationsRequest';
import type { TBulkUpdateNotificationsResponse } from '../models/TBulkUpdateNotificationsResponse';
import type { TGetNotificationResponse } from '../models/TGetNotificationResponse';
import type { TGetUnreadNotificationsCountResponse } from '../models/TGetUnreadNotificationsCountResponse';
import type { TListNotificationsResponse } from '../models/TListNotificationsResponse';
import type { TUpdateNotificationRequest } from '../models/TUpdateNotificationRequest';
import type { TUpdateNotificationResponse } from '../models/TUpdateNotificationResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationService {
    /**
     * List Notifications
     * @param unread
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListNotificationsResponse TListNotificationsResponse
     * @throws ApiError
     */
    public static listNotifications(
        unread?: boolean,
        limit?: number,
        page?: number,
        orderAsJsonString?: string,
        relations?: string,
    ): CancelablePromise<TListNotificationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notifications',
            query: {
                'unread': unread,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations,
            },
        });
    }
    /**
     * Get Unread Notifications Count
     * @returns TGetUnreadNotificationsCountResponse TGetUnreadNotificationsCountResponse
     * @throws ApiError
     */
    public static getUnreadCount(): CancelablePromise<TGetUnreadNotificationsCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notifications/unread-count',
        });
    }
    /**
     * Get Notification
     * @param id
     * @param relations
     * @returns TGetNotificationResponse TGetNotificationResponse
     * @throws ApiError
     */
    public static getNotification(
        id: string,
        relations?: string,
    ): CancelablePromise<TGetNotificationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notifications/{id}',
            path: {
                'id': id,
            },
            query: {
                'relations': relations,
            },
        });
    }
    /**
     * Update Notification
     * @param id
     * @param requestBody
     * @returns TUpdateNotificationResponse TUpdateNotificationResponse
     * @throws ApiError
     */
    public static updateNotification(
        id: string,
        requestBody: TUpdateNotificationRequest,
    ): CancelablePromise<TUpdateNotificationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/notifications/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Notification
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteNotification(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/notifications/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Bulk Update Notifications
     * @param requestBody
     * @returns TBulkUpdateNotificationsResponse void
     * @throws ApiError
     */
    public static bulkUpdate(
        requestBody: TBulkUpdateNotificationsRequest,
    ): CancelablePromise<TBulkUpdateNotificationsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/notifications/bulk-update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
